import React, { useEffect, useReducer, useState } from "react";
import { Link } from "react-router-dom";
import BasicTable from "../BasicTable/BasicTable";
import "./RestaurantTable.css";

const RestaurantTable = ({ allRestaurants }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [exp, setExp] = useState(false);
  let filterRestaurants = [];

  const filterTable = (searchTerm) => {
    filterRestaurants = [];
    if (searchTerm === "") {
      filterRestaurants = allRestaurants;
    } else {
      allRestaurants.forEach((item) => {
        if (
          item.restaurant_name.toLowerCase().includes(searchTerm.toLowerCase())
        ) {
          filterRestaurants.push(item);
        }
      });
    }
  };
  filterTable(searchTerm);

  return (
    <div style={{ backgroundColor: "white", padding: "10px 5px 20px" }}>
      <div className="restaurant-table-header">
        <p>Total Restaurants : {allRestaurants.length}</p>
        <div>
          <button
            className="btn__"
            style={{ backgroundColor: "#EF3340", color: "white" }}
          >
            <Link to="/createrestaurant">Add Restaurant</Link>
          </button>
          <button
            className="btn__"
            style={{ border: "1px solid #EF3340", color: "#EF3340" }}
            onClick={() => setExp(true)}
          >
            Export to Excel
          </button>
          <div className="input">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.16663 3.33317C5.94496 3.33317 3.33329 5.94484 3.33329 9.1665C3.33329 12.3882 5.94496 14.9998 9.16663 14.9998C12.3883 14.9998 15 12.3882 15 9.1665C15 5.94484 12.3883 3.33317 9.16663 3.33317ZM1.66663 9.1665C1.66663 5.02437 5.02449 1.6665 9.16663 1.6665C13.3088 1.6665 16.6666 5.02437 16.6666 9.1665C16.6666 13.3086 13.3088 16.6665 9.16663 16.6665C5.02449 16.6665 1.66663 13.3086 1.66663 9.1665Z"
                fill="#39424E"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.2857 13.2856C13.6111 12.9601 14.1388 12.9601 14.4642 13.2856L18.0892 16.9106C18.4147 17.236 18.4147 17.7637 18.0892 18.0891C17.7638 18.4145 17.2361 18.4145 16.9107 18.0891L13.2857 14.4641C12.9603 14.1387 12.9603 13.611 13.2857 13.2856Z"
                fill="#39424E"
              />
            </svg>
            <input
              type="text"
              placeholder="Search Restaurants"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div style={{ padding: "5px 20px" }}>
        <BasicTable restaurants={filterRestaurants} exp={exp} setExp={setExp} />
        {/* <TableContainer component={Paper}>
          {allRestaurants.length === 0 ? (
            <LoadingSkeleton />
          ) : (
            <Table
              sx={{ minWidth: 660 }}
              size="small"
              aria-label="a dense table"
              className="table"
            >
              <TableHead>
                <TableRow style={{ backgroundColor: "#f3f7f7" }}>
                  {headings.map((heading) => (
                    <TableCell>{heading}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody className="table-body">
                {allRestaurants
                  ?.filter((item) => {
                    if (searchTerm === " ") {
                      return item;
                    } else if (
                      item.restaurant_name
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                    ) {
                      return item;
                    }
                  })
                  .map((row, index) => (
                    <TableRow
                      hover
                      key={row._id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      style={{ fontSize: "1px" }}
                    >
                      <TableCell component="td" scope="row">
                        {row?._id}
                      </TableCell>
                      <TableCell>
                        <Link to={`/restaurants/${row._id}`}>
                          {row?.restaurant_name}
                        </Link>
                      </TableCell>
                      <TableCell>{row?.restuarant_type}</TableCell>
                      <TableCell>Static</TableCell>
                      <TableCell>{row?.address}</TableCell>
                      <TableCell>{convertTime(row.createdAt)}</TableCell>
                      <TableCell>Static</TableCell>
                      <TableCell>Static</TableCell>
                      <TableCell>{row?.ownerName}</TableCell>
                      <TableCell>{row?.phone}</TableCell>
                      <TableCell>Static</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          )}
        </TableContainer> */}
      </div>
    </div>
  );
};

export default RestaurantTable;

// <div>

//   <div className="flex items-center justify-between w-full ">

//     <p className="min-w-max font-semibold text-gray-700">Total Restaurants : 100</p>

//     <div className="flex items-center ">

//       <Link to="/createrestaurant"><button className="p-2 px-4 m-3 bg-red-400 text-white text-sm hover:bg-indigo-400">Add Restaurant</button></Link>
//       <button className="p-2 px-4 m-3  rounded-sm border-2 border-red-300 text-red-400 text-sm hover:border-indigo-400 hover:text-indigo-500">Export to Excel</button>

//       <div className="flex items-center px-4 bg-white rounded-md  border border-white hover:border-red-300">
//         <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//           <path fill-rule="evenodd" clip-rule="evenodd" d="M9.1665 3.33329C5.94484 3.33329 3.33317 5.94496 3.33317 9.16663C3.33317 12.3883 5.94484 15 9.1665 15C12.3882 15 14.9998 12.3883 14.9998 9.16663C14.9998 5.94496 12.3882 3.33329 9.1665 3.33329ZM1.6665 9.16663C1.6665 5.02449 5.02437 1.66663 9.1665 1.66663C13.3086 1.66663 16.6665 5.02449 16.6665 9.16663C16.6665 13.3088 13.3086 16.6666 9.1665 16.6666C5.02437 16.6666 1.6665 13.3088 1.6665 9.16663Z" fill="#39424E" />
//           <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2856 13.2857C13.611 12.9603 14.1387 12.9603 14.4641 13.2857L18.0891 16.9107C18.4145 17.2361 18.4145 17.7638 18.0891 18.0892C17.7637 18.4147 17.236 18.4147 16.9106 18.0892L13.2856 14.4642C12.9601 14.1388 12.9601 13.6111 13.2856 13.2857Z" fill="#39424E" />
//         </svg>
//         <input onChange={(e)=>setSearchTerm(e.target.value)} className="px-2 p-3 text-center text-gray-700 text-sm focus:outline-none  " placeholder="search query here" />
//       </div>
//       {/* search box ends here  */}
//     </div>

//   </div>

//   <div className="mt-3 flex flex-col">
//     <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
//       <div className="py-2 align-middle inline-block min-w-full sm:px-3 lg:px-8">
//         <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
//           <table className="min-w-full divide-y divide-gray-200">
//             <thead className="bg-gray-50">
//               <tr>
//                 <th
//                   scope="col"
//                   className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                 >
//                   ID
//                 </th>
//                 <th
//                   scope="col"
//                   className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                 >
//                   Name
//                 </th>
//                 <th
//                   scope="col"
//                   className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                 >
//                   Type
//                 </th>
//                 <th
//                   scope="col"
//                   className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                 >
//                   $DUE
//                 </th>

//                 <th
//                   scope="col"
//                   className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                 >
//                   Location
//                 </th>

//                 <th
//                   scope="col"
//                   className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                 >
//                   Created On
//                 </th>

//                 <th
//                   scope="col"
//                   className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                 >
//                   Reservations
//                 </th>

//                 <th
//                   scope="col"
//                   className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                 >
//                   Seating
//                 </th>

//                 <th
//                   scope="col"
//                   className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                 >
//                   Owner
//                 </th>

//                 <th
//                   scope="col"
//                   className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                 >
//                   Contact
//                 </th>

//                 <th
//                   scope="col"
//                   className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                 >
//                   Status
//                 </th>
//               </tr>
//             </thead>

//             <tbody className="bg-white divide-y divide-gray-200">

//               {allRestaurants && allRestaurants
//                 .filter((item) => {
//                   if (searchTerm === '') {
//                     return item;
//                   }

//                   if (item.restaurant_name.toLowerCase().includes(searchTerm.toLowerCase()) ) {
//                     return item;
//                   }

//                 })
//                 .map((item, index) => {

//                   return (
//                     <tr key={index}>
//                       <td className="px-3 py-4  whitespace-nowrap text-xs text-blue-400">
//                         {item._id}
//                       </td>

//                       <Link to={`/restaurants/${item._id}`}><td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-green-600 cursor-pointer hover:text-indigo-500">
//                         {item.restaurant_name}
//                       </td></Link>

//                       <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
//                         {item.restaurantType}
//                       </td>

//                       <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
//                         Static
//                       </td>

//                       <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
//                         {item.address}
//                       </td>

//                       <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
//                         {item.createdAt}
//                       </td>

//                       <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
//                         Staic
//                       </td>

//                       <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
//                         Staic
//                       </td>

//                       <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
//                         { item.ownerName }
//                       </td>

//                       <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
//                         {item.phone}
//                       </td>

//                       <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
//                         Staic
//                       </td>

//                     </tr>
//                   )
//                 })}

//             </tbody>
//           </table>

//           {allRestaurants.length === 0 && <p className="text-lg w-full text-center my-10"> Loading....</p>}

//         </div>
//       </div>
//     </div>
//   </div>
// </div>
